<div class="limit" *ngIf="config.displayLimits">
  <!-- 是否允许超上下限 -->
  <span
    [ngClass]="{
      hasEerror:
        !config.isLimitOverrideAllowed &&
        config.dataValue !== null &&
        config.lowerLimit !== null &&
        config.lowerLimit !== undefined &&
        config.dataValue < config.lowerLimit
    }"
    >{{ '下限值' }} : {{ config.lowerLimit }}</span
  >

  <span
    [ngClass]="{
      hasEerror:
        !config.isLimitOverrideAllowed &&
        config.dataValue !== null &&
        config.upperLimit !== null &&
        config.upperLimit !== undefined &&
        config.dataValue > config.upperLimit
    }"
    >{{ '上限值' }} : {{ config.upperLimit }}</span
  >
</div>
